export function Footer({ content }) {
  return (
    <footer className="site-footer" data-testid="footer-section">
      <div>
        <strong data-testid="footer-company-name">{content.company}</strong>
        <p data-testid="footer-address">{content.address}</p>
      </div>
      <div className="footer-links" data-testid="footer-links">
        {content.phone ? <a href={`tel:${content.phone}`} data-testid="footer-phone-link">{content.phone}</a> : null}
        {content.email ? <a href={`mailto:${content.email}`} data-testid="footer-email-link">{content.email}</a> : null}
      </div>
      <p data-testid="footer-copyright">{content.copyright}</p>
    </footer>
  );
}